import "@/App.css";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/site/Header";
import { Footer } from "./components/site/Footer";
import { MobileCallBar } from "./components/site/MobileCallBar";
import { CallbackProvider } from "./components/site/CallbackDialog";
import { SmoothScroll } from "./components/site/SmoothScroll";
import { ConsentBanner } from "./components/site/ConsentBanner";
import { AuthProvider, Protected } from "./components/admin/Auth";
import Home from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import Devis from "./pages/Devis";
import About from "./pages/About";
import Faq from "./pages/Faq";
import Contact from "./pages/Contact";
import { Blog, BlogPost } from "./pages/Blog";
import { MentionsLegales, Confidentialite } from "./pages/Legal";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/admin/Login";
import AdminDashboard from "./pages/admin/Dashboard";
import { SERVICES } from "./data/services";

const GSC = process.env.REACT_APP_GSC_VERIFICATION;

function SiteLayout() {
  return (
    <CallbackProvider>
      <a href="#contenu" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-white focus:px-4 focus:py-2">Aller au contenu</a>
      <Header />
      <main id="contenu"><Outlet /></main>
      <Footer />
      <MobileCallBar />
      <ConsentBanner />
    </CallbackProvider>
  );
}

function AdminLayout() {
  return <AuthProvider><Outlet /></AuthProvider>;
}

export default function App() {
  return (
    <HelmetProvider>
      <Helmet htmlAttributes={{ lang: "fr" }}>{GSC && <meta name="google-site-verification" content={GSC} />}</Helmet>
      <BrowserRouter>
        <SmoothScroll />
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            {SERVICES.map((s) => <Route key={s.key} path={s.path} element={<ServicePage k={s.key} />} />)}
            <Route path="/devis" element={<Devis />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-confidentialite" element={<Confidentialite />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route element={<AdminLayout />}>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Protected><AdminDashboard /></Protected>} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </HelmetProvider>
  );
}
